import { contentGeneratorConfigPopulatedSchema } from "@redotech/redo-model/content-generator-config/content-generator-config-definition";
import * as z from "zod/v4";

export const getContentGeneratorConfigPopulated = {
  name: "getContentGeneratorConfigPopulated" as const,
  input: z.object({ configId: z.string() }),
  output: contentGeneratorConfigPopulatedSchema,
};
